import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { catchError } from 'rxjs'
import { ToastService } from '../../shared/services/toast.service'

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router)
  const toatService = inject(ToastService)

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        router.navigateByUrl('/login')
      }
      toatService.showError(error.error.message)

      throw error
    })
  )
}
